import { createTokenManager } from '@hose/idp-jslib';
import { getParamFromUrl } from '../utils/tools'

import qs from 'qs'

const idpConfig = {
  clientId: 'hose-ai-chat',
  idpBaseUri: getParamFromUrl('idpHost') as string // 测试环境： 'https://idp.ekuaibao.net' // 线上环境：https://idp.hosecloud.com
}

class Login {
  fetcher: typeof window.fetch = window.fetch.bind(window);
  finishLogin = async () => {
    const tokenManager = createTokenManager({
      clientId: idpConfig.clientId,
      idpBaseUri: idpConfig.idpBaseUri,
    });
    const { code } = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });
    await tokenManager.finishLogin(code as string);
    window.history.replaceState(null, '', window.location.href.replace(/code=[0-9a-zA-Z_.-]*&?/, ''))
    const fetcher = tokenManager.decorateFetch(window.fetch.bind(window));
    this.fetcher = fetcher;
  };
}

const login = new Login();

export default login;
